import { FC, SVGProps } from 'react';

const TemplateIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({ color = '#fff', size = 20, ...props }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props} fill="none">
      <path
        d="M17.5 12.5786C17.5 14.883 15.9627 16.756 13.6819 16.7503H6.31811C4.0373 16.756 2.5 14.883 2.5 12.5786V7.42761C2.5 5.12571 4.0373 3.25031 6.31811 3.25031H13.6819C15.9627 3.25031 17.5 5.12571 17.5 7.42761V12.5786Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.4272 7.63837L11.0947 10.3481C10.4672 10.8468 9.57775 10.8468 8.95016 10.3481L5.58936 7.63837"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default TemplateIcon;
